import { ProductLogoMediumPlaces as LogoPlaces } from "@/components/Logo";
import type { TabWithIndicatorProps } from "@/components/Navigation/HeaderTabs";
import { ProductHeader } from "@/components/ProductHeader";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { useTranslation } from "@/lib/i18n";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_staff/places/_layout")({
  component: Layout,
});

function Layout() {
  const { t } = useTranslation();
  useDocumentTitle(t("pages.places.list.pageTitle"));

  const tabs = [
    {
      to: "/places/overview",
      children: t("common.list.overview"),
      activeOptions: { exact: true },
    },
    {
      to: "/places",
      children: t("common.list.places"),
      activeOptions: { exact: true, includeSearch: true },
    },
    {
      to: "/places/people",
      children: t("common.list.people"),
      activeOptions: { exact: true },
    },
    {
      to: "/places/alerts",
      children: t("common.list.alerts"),
      activeOptions: { exact: true },
    },
    {
      to: "/places/contract-and-cost",
      children: t("common.list.contractAndCost"),
      activeOptions: { exact: true },
    },
    {
      to: "/places/operation-activity",
      children: t("common.list.operationActivity"),
      activeOptions: { exact: true },
    },
    {
      to: "/places/store",
      children: t("common.list.store"),
      activeOptions: { exact: true },
    },
    {
      to: "/places/rule-and-policy",
      children: t("common.list.ruleAndPolicy"),
      activeOptions: { exact: true },
    },
    {
      to: "/places/settings",
      children: t("common.list.settings"),
      activeOptions: { exact: true },
    },
  ] satisfies TabWithIndicatorProps[];

  return (
    <div className="flex flex-col">
      <ProductHeader
        Logo={LogoPlaces}
        name={t("pages.places.list.pageTitle")}
        tabs={tabs}
        type="resource"
      />
      <Outlet />
    </div>
  );
}
